import styled from "styled-components";

export const Container = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 85vh;
  width: 100%;
  h2,
  p {
    width: 80%;
    margin: 1rem auto;
    text-align: center;
  }
  form {
    width: 90vw;
    .form-group {
      display: flex;
      flex-direction: column;
      input {
        padding: 1rem;
        margin: 1rem 0;
        border-radius: 14px;
        border: 1px solid #cccccc;
      }
    }
    .personal-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      .buyer-name {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      .messagge input {
        height: 100px;
      }
    }
  }
  .btns-container {
    display: flex;
    margin: 1rem auto;
  }
`;
